import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const RatingContainer = styled.span<{ gap?: number }>`
  display: flex;
  align-items: center;
  gap: ${(props) => (props.gap ? props.gap : 2)}px;
`;

export const RatingInfo = styled.span<{ fontSize?: number }>`
  display: flex;
  gap: 6px;
  font-size: ${(props) => (props.fontSize ? props.fontSize : 12)}px;
  color: var(--color-ui-grayscale-gray-400);
  user-select: none;

  .review-cnt {
    cursor: pointer;
  }
`;

export const StarWrapper = styled.div<{ readonly: boolean }>`
  transition: 0.2s opacity ease-in;

  ${(props) =>
    !props.readonly &&
    css`
      :hover {
        cursor: pointer;
        opacity: 0.4;
      }
    `}
`;
